import { render, staticRenderFns } from "./CypressInitPage.vue?vue&type=template&id=37688705"
import script from "./CypressInitPage.vue?vue&type=script&lang=js"
export * from "./CypressInitPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports